///
/// EarthBrowser
///
/// Created by Matt Giger on 10/11/2026
/// Copyright (c) 2026 Geodata Labs
///
/// Shapes exchanged between time-based layers and the timeline UI. Kept
/// dependency-free so both the engine and React side can import them.

/**
 * Which lane drives frame stepping when several frame-based layers are
 * visible: finest cadence first. Also the order the timeline picks the
 * lane to report as "showing an older frame" while textures stream in
 */
export const cFrameStepPrecedence = ["radar", "radar_forecast", "mrms", "nexrad", "imerg", "clouds", "cloud_forecast", "aurora", "sst", "synoptic"]

/**
 * Lanes that continue another lane in time: frame stepping on the primary
 * lane carries on into the extension's frames past the primary's last one
 * (the observed radar mosaic and clouds hand off to the RRFS forecasts)
 */
export const cFrameLaneExtensions: Record<string, string> = { radar: "radar_forecast", clouds: "cloud_forecast" }

/** A span of time in epoch milliseconds */
export interface TimeSpanMs {
	startMs: number
	endMs: number
}

/** Per-frame detail a time-based layer can expose beyond its overall range */
export interface TimeLaneDetail {
	/** Start time of every frame, ascending (empty when the layer has no discrete frames) */
	frameTimesMs: number[]
	/** Spans whose data is loaded and displayable right now */
	loadedRanges: TimeSpanMs[]
	/**
	 * Start of the frame actually on screen while it differs from the one
	 * the clock asks for (a fallback shown during loading); undefined when
	 * the picture matches the clock
	 */
	displayedFrameMs?: number
}

/** One lane on the timeline: a visible time-based layer's availability */
export interface TimeLane extends TimeSpanMs {
	id: string
	frameTimesMs: number[]
	loadedRanges: TimeSpanMs[]
	displayedFrameMs?: number
}
